import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { shouldShowAddUserDialog } from '../actions/internalActions';

// mutates showLoader flag which shows Ad
export const shouldShowAddUserDialogMutator = mutator(shouldShowAddUserDialog, actionMessage => {
    getStore().showAddUserDialog = actionMessage.shouldShow;
});
